import { createEmployerClientSchema } from '../shared/validations/employerValidations';
import { AddressFields } from './AddressForm';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { Divider } from 'antd';
import translations from './ComponentsTranslations.lang.json';
import { useLanguage } from '../utils/LanguageContext.js';
import { useAuth } from '../utils/AuthContext.js';

const EmployerForm = ({ employer, onFinish, submitLabel }) => {
  const { lang } = useLanguage(translations);
  const { api } = useAuth();

  const { employerId, employerName, payrollProvider, employerContact, employerAddress } = employer || {};

  const handleSubmit = async (values) => {
    if (employerId) {
      await api.updateEmployer(employerId, values);
    } else {
      const employerId = await api.createEmployer(values);
      return { employerId };
    }
  };

  return (
    <ValidatedForm
      key="employer"
      schema={createEmployerClientSchema}
      initialValues={{ employerName, payrollProvider, employerContact, employerAddress }}
      handleSubmit={handleSubmit}
      onFinish={onFinish}
    >
      <FormInput name="employerName" type="text" />
      <FormInput name="payrollProvider" type="text" />
      <Divider type="horizontal" orientation="left">
        {lang('employerContactTitle')}
      </Divider>
      <FormInput name="employerContact.name.givenName" type="text" />
      <FormInput name="employerContact.name.familyName" type="text" />
      <FormInput name="employerContact.title" type="text" />
      <FormInput name="employerContact.email" type="email" />
      <FormInput name="employerContact.phoneNumber" type="text" />
      <Divider type="horizontal" orientation="left">
        {lang('employerAddressTitle')}
      </Divider>
      <AddressFields prefix="employerAddress" />
      <FormSubmit>{submitLabel}</FormSubmit>
    </ValidatedForm>
  );
};

export default EmployerForm;
